import { clientLogos } from "@/content/clients";
import { SectionHead } from "@/components/common/Bits";

// One continuously scrolling row. The list is rendered twice so the -50% translate loops seamlessly;
// the duplicate copy is hidden from assistive tech. Pauses on hover/focus; static + scrollable for reduced motion.
const Row = ({ logos, reverse = false, label }) => (
  <div className="group relative overflow-hidden motion-reduce:overflow-x-auto" role="group" aria-label={label}>
    <ul className={`flex w-max items-center gap-4 py-2 [animation-play-state:running] group-hover:[animation-play-state:paused] motion-reduce:animate-none ${reverse ? "animate-marquee-reverse" : "animate-marquee"}`}>
      {[...logos, ...logos].map((l, i) => {
        const dup = i >= logos.length;
        return (
          <li key={`${l.src}-${i}`} aria-hidden={dup || undefined} className="flex h-24 w-44 flex-none items-center justify-center rounded-xl border border-line bg-white px-5 py-4">
            <img src={l.src} alt={dup ? "" : `${l.name} logo`} width={l.w} height={l.h} loading="lazy" decoding="async" className="max-h-full max-w-full object-contain" />
          </li>
        );
      })}
    </ul>
  </div>
);

export const ClientLogos = ({ className = "" }) => {
  const half = Math.ceil(clientLogos.length / 2);
  return (
    <section className={`overflow-hidden bg-paper py-16 sm:py-20 ${className}`} aria-labelledby="clients-title" data-testid="client-logos">
      <div className="container-x">
        <SectionHead eyebrow="Our clients" title="Trusted by growing businesses." lede="A selection of the brands that have worked with us." align="center" className="!mb-10 lg:!mb-12" />
        <h2 id="clients-title" className="sr-only">Client logos</h2>
      </div>
      <div className="space-y-4 [mask-image:linear-gradient(to_right,transparent,#000_6%,#000_94%,transparent)]">
        <Row logos={clientLogos.slice(0, half)} label="Client logos, first row" />
        <Row logos={clientLogos.slice(half)} reverse label="Client logos, second row" />
      </div>
    </section>
  );
};
